var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Active & Legging Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Active & Legging Line",
      "file": "active"
    }
  }, [_vm._v(" Single/Double knit with printing and foil design, Special pattern with Embossing, Very stretchy and recoverable quality. We have a lot of experience and buyers for these sports & Legging items. Offer your customers affordable and high-quality clothing. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }